import script from "./DocumentTemplateList.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentTemplateList.vue?vue&type=script&setup=true&lang=js"

import "./DocumentTemplateList.vue?vue&type=style&index=0&id=556cc478&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-556cc478"]])

export default __exports__